export default __webpack_public_path__ + "static/media/custom-icon.623be3b6.svg";